module.exports = __webpack_public_path__ + "img/food-23.2a015d16.jpg";